import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiButtonModule } from "@taiga-ui/core";
import { KwikUISafeHtmlPipeModule } from "../../../pipes/safe-html/safe-html.module";
import { KwikUIImageComponent } from "./image.component";

@NgModule({
  declarations: [KwikUIImageComponent],
  imports: [CommonModule, TuiButtonModule, KwikUISafeHtmlPipeModule],
  exports: [KwikUIImageComponent]
})
export class KwikUIImageModule {}
